import { render, staticRenderFns } from "./widgetSecThreatGeoTopn.vue?vue&type=template&id=5829b893&scoped=true&"
import script from "./widgetSecThreatGeoTopn.vue?vue&type=script&lang=js&"
export * from "./widgetSecThreatGeoTopn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5829b893",
  null
  
)

export default component.exports